import { setNameRowLodging } from "../setNameRowLodging"

export const getLodgingRequiredFields = (index: number) => [
  `${setNameRowLodging(index)}.lodgingCheckin`,
  `${setNameRowLodging(index)}.lodgingCheckout`,
  `${setNameRowLodging(index)}.lodgingName`,
]
